import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=04f6c4b8&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=ts&"
export * from "./Admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6c4b8",
  null
  
)

export default component.exports